/* =============================================================================
   shop-the-look-custom.js
============================================================================= */

(function () {
	'use strict';

	const SECTION   = '.js-stl';
	const SLIDE     = '.js-stl-slide';
	const POINT     = '.js-stl-point';
	const BTN_PREV  = '.js-stl-prev';
	const BTN_NEXT  = '.js-stl-next';
	const ACTIVE    = 'is-active';

	/**
	 * Initialise one section instance
	 */
	function initSection(section) {
		const slides  = [...section.querySelectorAll(SLIDE)];
		const points  = [...section.querySelectorAll(POINT)];
		const btnPrev = section.querySelector(BTN_PREV);
		const btnNext = section.querySelector(BTN_NEXT);

		if (!slides.length) return;

		let current = 0;


		function goTo(index) {
			if (index < 0 || index >= slides.length || index === current) return;

			deactivate(slides[current]);
			deactivate(points[current]);

			current = index;

			activate(slides[current]);
			activate(points[current]);

			updateArrows();
		}

		function activate(el) {
			if (!el) return;
			el.classList.add(ACTIVE);
			el.setAttribute('aria-hidden', 'false');
		}

		function deactivate(el) {
			if (!el) return;
			el.classList.remove(ACTIVE);
			el.setAttribute('aria-hidden', 'true');
		}

		function updateArrows() {
			if (btnPrev) btnPrev.disabled = current === 0;
			if (btnNext) btnNext.disabled = current === slides.length - 1;
		}


		if (btnPrev) {
			btnPrev.addEventListener('click', () => goTo(current - 1));
		}

		if (btnNext) {
			btnNext.addEventListener('click', () => goTo(current + 1));
		}

		points.forEach((point) => {
			point.addEventListener('click', () => {
				const index = parseInt(point.getAttribute('data-point-index'), 10);
				goTo(index);
			});
		});

		section.addEventListener('keydown', (e) => {
			if (e.key === 'ArrowLeft')  goTo(current - 1);
			if (e.key === 'ArrowRight') goTo(current + 1);
		});

		const track = section.querySelector('.stl__track');
		if (track) {
			let startX = null;

			track.addEventListener('touchstart', (e) => {
				startX = e.touches[0].clientX;
			}, { passive: true });

			track.addEventListener('touchend', (e) => {
				if (startX === null) return;
				const diff = startX - e.changedTouches[0].clientX;
				if (Math.abs(diff) > 40) {
					diff > 0 ? goTo(current + 1) : goTo(current - 1);
				}
				startX = null;
			}, { passive: true });
		}

		updateArrows();
	}


	function init() {
		document.querySelectorAll(SECTION).forEach(initSection);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', (e) => {
		const section = e.target.querySelector(SECTION);
		if (section) initSection(section);
	});

})();